import { Badge } from 'antd';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { menu } from '@/configs/router/menu';
import Paths from '@/configs/router/paths';
import styles from './index.module.scss';

const comingSoonModules = [Paths.CALLS, Paths.FEEDS, Paths.SHORTS, Paths.Wallet];

const NavMenu = ({ collapse, className }: { collapse: boolean; className: string }) => {
  const navigate = useNavigate();
  const _location = useLocation();
  const [cacheMenu, setCacheMenu] = useState<Record<string, any>>({});

  useEffect(() => {
    const curMenuItem: any = menu.find((menuItem) =>
      _location.pathname.includes(menuItem.key as string)
    );
    if (curMenuItem?.key) {
      if (
        (cacheMenu[curMenuItem?.key] &&
          cacheMenu[curMenuItem?.key] !== _location.pathname) ||
        !cacheMenu[curMenuItem?.key]
      ) {
        cacheMenu[curMenuItem?.key] = _location.pathname;
        setCacheMenu({ ...cacheMenu });
      }
    }
  }, [cacheMenu, _location.pathname]);

  return (
    <div className={cls(styles.menu, className)}>
      {menu.map((item) => {
        return (
          <div
            key={item.key}
            className={cls(
              styles.menuItemWrapper,
              (item.key as string)?.includes(Paths.MESSAGES_PATH) &&
                styles.menuItemSticky
            )}
          >
            <div
              className={cls(
                styles.menuItem,
                _location.pathname.includes(item.key as string) && styles.activeItem
              )}
              onClick={() => {
                if (comingSoonModules.includes(item.key as any)) {
                  return message.info('Coming soon.');
                }
                if (item.key === Paths.MESSAGES_PATH) {
                  navigate(cacheMenu[item.key as string] || Paths.MESSAGES_CHATS);
                  return;
                }
                navigate(cacheMenu[item.key as string] || item.key);
              }}
            >
              <Badge className={styles.badge} count={collapse ? 0 : 0}>
                <span className={styles.icon}>
                  {_location.pathname.includes(item.key as string)
                    ? item.activeIcon
                    : item.icon}
                </span>
              </Badge>
              <span className={styles.label}>{item.label}</span>
              {!collapse && <Badge className={styles.badge} count={0}></Badge>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NavMenu;
